'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ImpressionsChartClient = dynamic(() => import('./ImpressionsChartClient'), { ssr: false });

export default function ImpressionsChart() {
  return (
    <div className="card-surface p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-base text-foreground">Search Impressions</h3>
          <p className="text-xs text-muted-foreground">Weekly impressions over the last 12 weeks</p>
        </div>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-1 bg-primary rounded-full inline-block" />
            Impressions
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-1 bg-accent rounded-full inline-block" />
            Category Avg
          </span>
        </div>
      </div>
      <ImpressionsChartClient />
    </div>
  );
}